import { APPBAR_WITHOUT_MODULES_HEIGHT, styled } from "@l2r-front/l2r-ui"

export const ContentWrapper = styled("div")({
    boxSizing: "border-box",
    display: "flex",
    height: "100%",
    justifyContent: "space-around",
    paddingTop: APPBAR_WITHOUT_MODULES_HEIGHT,
    position: "relative",
    width: "100%",
})

export const PageWrapper = styled("div", {
    shouldForwardProp: (prop) => prop !== "isLargeScreen",
})(({ isLargeScreen, theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    height: "100%",
    overflowY: "auto",
    width: isLargeScreen ? "50%" : "100%",
}))

export const Image = styled("img")({
    height: "100%",
    width: "50%",
    objectFit: "cover",
})

export const Container = styled("div")({
    display: "flex",
    height: "100%",
    width: "100%",
})